import React from 'react';

const KeyboardsIcon = ({ width = 260, height = 260, ...svgProps }) => (
    <svg
        width={width}
        height={height}
        {...svgProps}
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0.79 218 132.21'
    >
        <rect x='22.5' y='1.28882' width='195' height='98' rx='7.5' fill='white'></rect>
        <rect x='22.5' y='1.28882' width='195' height='98' rx='7.5' stroke='#EFEDF1'></rect>
        <g clipPath='url(#clip0_65995_76531)'>
            <rect
                x='29.4536'
                y='14.885'
                width='131.367'
                height='13.9752'
                rx='3.73'
                fill='#EFEDF1'
            ></rect>
            <rect
                x='29.4536'
                y='31.6552'
                width='83.3852'
                height='13.9752'
                rx='3.73'
                fill='#EFEDF1'
            ></rect>
            <g clipPath='url(#clip1_65995_76531)'>
                <rect
                    x='29.4536'
                    y='52.1522'
                    width='49.379'
                    height='14.9069'
                    rx='3.72671'
                    fill='#EFEDF1'
                ></rect>
            </g>
            <g clipPath='url(#clip2_65995_76531)'>
                <rect
                    x='82.5591'
                    y='52.152'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='#EFEDF1'
                ></rect>
            </g>
            <g clipPath='url(#clip3_65995_76531)'>
                <rect
                    x='123.553'
                    y='52.1522'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='#EFEDF1'
                ></rect>
            </g>
            <g clipPath='url(#clip4_65995_76531)'>
                <rect
                    x='29.4536'
                    y='70.7856'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='#EFEDF1'
                ></rect>
            </g>
            <g clipPath='url(#clip5_65995_76531)'>
                <rect
                    x='70.4473'
                    y='70.7857'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='#EFEDF1'
                ></rect>
            </g>
            <g clipPath='url(#clip6_65995_76531)'>
                <rect
                    x='111.441'
                    y='70.7856'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='#EFEDF1'
                ></rect>
            </g>
            <g clipPath='url(#clip7_65995_76531)'>
                <rect
                    x='152.435'
                    y='70.7857'
                    width='21.4286'
                    height='14.9069'
                    rx='3.72671'
                    fill='#EFEDF1'
                ></rect>
            </g>
        </g>
        <rect x='0.5' y='34.5' width='195' height='98' rx='7.5' fill='white'></rect>
        <rect x='0.5' y='34.5' width='195' height='98' rx='7.5' stroke='#EFEDF1'></rect>
        <g clipPath='url(#clip8_65995_76531)'>
            <rect
                x='7.45361'
                y='48.0962'
                width='131.367'
                height='13.9752'
                rx='3.73'
                fill='#EFEDF1'
            ></rect>
            <rect
                x='7.45361'
                y='64.8664'
                width='83.3852'
                height='13.9752'
                rx='3.73'
                fill='#EFEDF1'
            ></rect>
            <g clipPath='url(#clip9_65995_76531)'>
                <rect
                    x='7.45361'
                    y='85.3633'
                    width='49.379'
                    height='14.9069'
                    rx='3.72671'
                    fill='#EFEDF1'
                ></rect>
            </g>
            <g clipPath='url(#clip10_65995_76531)'>
                <rect
                    x='60.5591'
                    y='85.3632'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='#EFEDF1'
                ></rect>
            </g>
            <g clipPath='url(#clip11_65995_76531)'>
                <rect
                    x='101.553'
                    y='85.3633'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='#EFEDF1'
                ></rect>
            </g>
            <g clipPath='url(#clip12_65995_76531)'>
                <rect
                    x='7.45361'
                    y='103.997'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='#EFEDF1'
                ></rect>
            </g>
            <g clipPath='url(#clip13_65995_76531)'>
                <rect
                    x='48.4473'
                    y='103.997'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='#EFEDF1'
                ></rect>
            </g>
            <g clipPath='url(#clip14_65995_76531)'>
                <rect
                    x='89.4414'
                    y='103.997'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='#EFEDF1'
                ></rect>
            </g>
            <g clipPath='url(#clip15_65995_76531)'>
                <rect
                    x='130.435'
                    y='103.997'
                    width='21.4286'
                    height='14.9069'
                    rx='3.72671'
                    fill='#EFEDF1'
                ></rect>
            </g>
        </g>
        <defs>
            <clipPath id='clip0_65995_76531'>
                <rect
                    width='166.186'
                    height='70.8076'
                    fill='white'
                    transform='translate(29.4536 14.885)'
                ></rect>
            </clipPath>
            <clipPath id='clip1_65995_76531'>
                <rect
                    x='29.4536'
                    y='52.1522'
                    width='49.379'
                    height='14.9069'
                    rx='3.72671'
                    fill='white'
                ></rect>
            </clipPath>
            <clipPath id='clip2_65995_76531'>
                <rect
                    x='82.5591'
                    y='52.152'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='white'
                ></rect>
            </clipPath>
            <clipPath id='clip3_65995_76531'>
                <rect
                    x='123.553'
                    y='52.1522'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='white'
                ></rect>
            </clipPath>
            <clipPath id='clip4_65995_76531'>
                <rect
                    x='29.4536'
                    y='70.7856'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='white'
                ></rect>
            </clipPath>
            <clipPath id='clip5_65995_76531'>
                <rect
                    x='70.4473'
                    y='70.7857'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='white'
                ></rect>
            </clipPath>
            <clipPath id='clip6_65995_76531'>
                <rect
                    x='111.441'
                    y='70.7856'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='white'
                ></rect>
            </clipPath>
            <clipPath id='clip7_65995_76531'>
                <rect
                    x='152.435'
                    y='70.7857'
                    width='21.4286'
                    height='14.9069'
                    rx='3.72671'
                    fill='white'
                ></rect>
            </clipPath>
            <clipPath id='clip8_65995_76531'>
                <rect
                    width='166.186'
                    height='70.8076'
                    fill='white'
                    transform='translate(7.45361 48.0962)'
                ></rect>
            </clipPath>
            <clipPath id='clip9_65995_76531'>
                <rect
                    x='7.45361'
                    y='85.3633'
                    width='49.379'
                    height='14.9069'
                    rx='3.72671'
                    fill='white'
                ></rect>
            </clipPath>
            <clipPath id='clip10_65995_76531'>
                <rect
                    x='60.5591'
                    y='85.3632'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='white'
                ></rect>
            </clipPath>
            <clipPath id='clip11_65995_76531'>
                <rect
                    x='101.553'
                    y='85.3633'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='white'
                ></rect>
            </clipPath>
            <clipPath id='clip12_65995_76531'>
                <rect
                    x='7.45361'
                    y='103.997'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='white'
                ></rect>
            </clipPath>
            <clipPath id='clip13_65995_76531'>
                <rect
                    x='48.4473'
                    y='103.997'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='white'
                ></rect>
            </clipPath>
            <clipPath id='clip14_65995_76531'>
                <rect
                    x='89.4414'
                    y='103.997'
                    width='37.2671'
                    height='14.9069'
                    rx='3.72671'
                    fill='white'
                ></rect>
            </clipPath>
            <clipPath id='clip15_65995_76531'>
                <rect
                    x='130.435'
                    y='103.997'
                    width='21.4286'
                    height='14.9069'
                    rx='3.72671'
                    fill='white'
                ></rect>
            </clipPath>
        </defs>
    </svg>
);

export { KeyboardsIcon };
